export const formItemLayout = {
	labelCol: {span: 8},
	wrapperCol: {span: 15},
}
